// extracted by mini-css-extract-plugin
export var container = "H1WithLink-module--container--PKUCn";
export var link = "H1WithLink-module--link--SqkJ-";